import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoadingComponent } from '../components/common/loading/loading.component';
import { DescargaRedirectComponent } from '../components/common/descarga-redirect/descarga-redirect.component';

@NgModule({
  declarations: [
    LoadingComponent,
    DescargaRedirectComponent,
  ],
  imports:[
    CommonModule
  ],
  exports:[
    LoadingComponent,
    DescargaRedirectComponent
  ],
})
export class CommonComponentsModule { }
